"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { openConsentBanner } from "./consent";
/** English defaults — apps pass localized strings via the `labels` prop. */
const DEFAULT_LABELS = {
    terms: "Terms",
    privacy: "Privacy",
    cookieSettings: "Cookie settings",
    imprint: "Imprint",
    contact: "Contact",
    rights: "© {year} OwlCat Club. All rights reserved.",
};
export function LegalFooter({ accountsUrl, contactEmail = "info@owlcat.club", labels, ariaLabel = "Legal", className = "", linkComponent, }) {
    const t = { ...DEFAULT_LABELS, ...labels };
    const L = linkComponent ?? "a";
    const base = (accountsUrl ?? "").trim().replace(/\/+$/, "");
    const year = new Date().getFullYear();
    // The originating URL, appended as `?return=` so the accounts /info pages can
    // render a "← Back" button. Read window ONLY after mount (in an effect) to
    // avoid a hydration mismatch — SSR renders the bare accounts link, the client
    // enriches it on mount. accounts open-redirect-guards the value regardless.
    const [ret, setRet] = useState("");
    useEffect(() => {
        setRet(window.location.href);
    }, []);
    const info = (path) => ret ? `${base}${path}?return=${encodeURIComponent(ret)}` : `${base}${path}`;
    const linkClass = "text-sm text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline focus-visible:text-foreground";
    return (_jsx("footer", { 
        // mt-auto pins the footer to the viewport bottom in a flex-column layout
        // (min-h-dvh flex flex-col body) even when the page is short; it is a no-op
        // in normal block flow, so it is always safe as a default.
        className: `mt-auto w-full border-t border-border bg-background ${className}`.trim(), "data-testid": "legal-footer", children: _jsxs("div", { className: "mx-auto flex max-w-5xl flex-col items-center gap-3 px-4 py-6 text-center sm:flex-row sm:justify-between sm:text-left", children: [_jsxs("nav", { "aria-label": ariaLabel, className: "flex flex-wrap items-center justify-center gap-x-5 gap-y-2 sm:justify-start", children: [_jsx(L, { href: info("/info/terms"), className: linkClass, "data-testid": "legal-footer-terms", children: t.terms }), _jsx(L, { href: info("/info/privacy"), className: linkClass, "data-testid": "legal-footer-privacy", children: t.privacy }), _jsx("button", { type: "button", onClick: () => openConsentBanner(), className: `${linkClass} cursor-pointer bg-transparent p-0`, "data-testid": "legal-footer-cookies", children: t.cookieSettings }), _jsx("a", { href: `mailto:${contactEmail}`, className: linkClass, "data-testid": "legal-footer-contact", children: t.contact })] }), _jsx("p", { className: "text-xs text-muted-foreground", "data-testid": "legal-footer-rights", children: t.rights.includes("{year}")
                        ? t.rights.replace("{year}", String(year))
                        : t.rights })] }) }));
}
